import { Button, Drawer, Form, InputNumber, Select, Input, message, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { db } from "../../firebase/config";
import { doc, serverTimestamp, updateDoc } from "firebase/firestore";

const { Link } = Typography;

export default function EditSRoll({ rollProp, materialLoading, materialData }) {
   const [open, setOpen] = useState(false);
   const [selectedMaterial, setSelectedMaterial] = useState();
   const [form] = Form.useForm();

   useEffect(() => {
      if (open) {
         //checks if its open
         form.setFieldsValue({
            //sets the field values from prop
            remainingMeters: rollProp.remainingMeters,
            rollWidth: rollProp.rollWidth,
            comment: rollProp.comment,
            selectedMaterialID: rollProp.selectedMaterialID,
         });
         setSelectedMaterial(rollProp.material);
      }
   }, [open, form, rollProp]);

   const showDrawer = () => {
      setOpen(true);
   };
   const onClose = () => {
      setOpen(false);
   };

   //when a form finishes
   const onFinish = (values) => {
      const data = {
         //creates a data and tells the comment could also be empty
         ...values,
         comment: values.comment || "", // Set the comment field to an empty string if it's not set explicitly in the form
      };
      updateRoll(data);
   };
   //if form failed
   const onFinishFailed = (errorInfo) => {
      message.error("Failed:", errorInfo);
   };

   const handleMaterialChange = (value, object) => {
      setSelectedMaterial(object);
   };

   //updates the roll
   const updateRoll = async (data) => {
      const newData = {
         //populates the form data with the selected material from state
         ...data,
         material: selectedMaterial,
         updated: serverTimestamp(), //adds timestamps
      };

      const ref = doc(db, "secondWarehouseRolls", rollProp.id);
      try {
         updateDoc(ref, newData).then(() => {
            message.success(`Success! Roll has been updated!.`);
            setOpen(false);
            form.resetFields(); // Reset form fields after the data is successfully added
         });
      } catch (err) {
         message.error(err.message);
      }
   };
   return (
      <>
         <Link onClick={showDrawer}>edit</Link>
         <Drawer title="Edit roll" placement="right" onClose={onClose} open={open} width={500}>
            <Form form={form} name="basic" onFinish={onFinish} layout="vertical" onFinishFailed={onFinishFailed} autoComplete="off" style={{ width: "100%" }}>
               <Form.Item
                  label="Material"
                  name="selectedMaterialID"
                  rules={[
                     {
                        required: true,
                        message: "Please input Meters",
                     },
                  ]}
               >
                  <Select
                     showSearch
                     placeholder="Select a material"
                     optionFilterProp="children"
                     loading={materialLoading}
                     onChange={handleMaterialChange}
                     fieldNames={{ label: "material", value: "id" }}
                     filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                     options={materialData && materialData}
                  />
               </Form.Item>

               <Form.Item
                  label="Meters"
                  name="remainingMeters"
                  rules={[
                     {
                        required: true,
                        message: "Please input Meters",
                     },
                  ]}
               >
                  <InputNumber style={{ width: "100%" }} placeholder="Enter the amount of meters inside Material roll" />
               </Form.Item>

               <Form.Item
                  label="Width"
                  name="rollWidth"
                  rules={[
                     {
                        required: true,
                        message: "Please input Meters",
                     },
                  ]}
               >
                  <InputNumber style={{ width: "100%" }} placeholder="Enter width of the roll" />
               </Form.Item>

               <Form.Item name="comment" label="Comment">
                  <Input.TextArea name="comment" rows={2} placeholder="Roll comment" />
               </Form.Item>

               <Form.Item>
                  <Button type="primary" htmlType="submit">
                     Update
                  </Button>
               </Form.Item>
            </Form>
         </Drawer>
      </>
   );
}
